// extracted by mini-css-extract-plugin
module.exports = {"container":"CohortPopup_container__1DYoZ","content":"CohortPopup_content__UEIsR","header":"CohortPopup_header__FUGvx","footer":"CohortPopup_footer__1max8"};